import React from 'react';
import { enterKeyHandler } from 'window-utils/lib/keyHandlerUtils';
import { isConsumer } from 'owa-shared-start/lib/sessionDiagnostics';
import {
    getNativeAdShowStatus,
    isGdprAdMarket,
    NativeAdUserFlight,
} from 'mini-mail-nativead-userchecker';

const styles = require('./BinarySwitch.scss');
const classNames = require('classnames/bind').bind(styles);

interface BinarySwitchProps {
    leftLabel: string;
    rightLabel: string;
    onClick?: (isLeftSelectedNow: boolean) => void;
    className?: string;
    selectedButtonClass?: string;
    freeButtonClass?: string;
    getAriaLabel?: (isLeftSideSelected: boolean) => string;
    isLeftSelected?: boolean;
}

export const BinarySwitch = React.forwardRef(
    (props: BinarySwitchProps, ref?: React.RefObject<any>): JSX.Element => {
        const {
            className,
            leftLabel,
            rightLabel,
            freeButtonClass,
            selectedButtonClass,
            getAriaLabel,
            onClick,
            isLeftSelected = true,
        } = props;

        const bannerView =
            isConsumer() &&
            isGdprAdMarket() &&
            getNativeAdShowStatus() == NativeAdUserFlight.PrebidMobileBannerAd;

        const onSwitchClick = () => {
            const newIsLeftSelected = !isLeftSelected;
            onClick && onClick(newIsLeftSelected);
        };

        const renderSide = (label: string, isSelected: boolean) => (
            <div
                className={classNames(
                    {
                        [styles.pillBanner]: bannerView,
                        [styles.pill]: !bannerView,
                    },
                    isSelected
                        ? classNames(
                              {
                                  [styles.selectedSideBanner]: bannerView,
                                  [styles.selectedSide]: !bannerView,
                              },
                              selectedButtonClass
                          )
                        : freeButtonClass
                )}>
                {label}
            </div>
        );

        return (
            <div
                className={classNames(styles.switchContainer, className)}
                onClick={onSwitchClick}
                onKeyUp={enterKeyHandler(onSwitchClick)}
                role="button"
                ref={ref}
                tabIndex={0}
                aria-label={getAriaLabel ? getAriaLabel(isLeftSelected) : ''}>
                {renderSide(leftLabel, isLeftSelected)}
                {renderSide(rightLabel, !isLeftSelected)}
            </div>
        );
    }
);
